<template lang="pug">
  section.content(v-if="contents && contents.length" ref="container" :class="classes" :style="style")
    .content-wrap(:class="imagePosition")
      .images(v-if="images && images.length")
        PostImage(
          v-for="image in images" :key="image.id"
          :content="image"
        )
      .content(:class="[descBackgroundColor, imagePosition]")
        Heading(:heading="heading.title" :subHeading="heading.sub_title")
        .desc(v-if="content && content.text" v-html="content.text")
</template>

<script>
import Heading from './Heading';
import PostImage from './PostImage';

import section from '@/mixins/section';

export default {
  name: 'Post',
  mixins: [section],
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  components: {
    Heading,
    PostImage
  },
  computed: {
    contents() {
      return this.section.contents || [];
    },
    heading() {
      return this.contents.find(content => content.key === 'heading');
    },
    content() {
      return this.contents.find(content => content.key === 'content');
    },
    images() {
      return this.contents.filter(content => content.key === 'image');
    },
    descBackgroundColor() {
      let color = 'colorTrans';

      if (this.settings.length) {
        const setting = this.settings.find(setting => setting.key === 'desc_backgroundcolor');
        if (setting && setting.value !== undefined) color = setting.value;
      }

      return color;
    },
    imagePosition() {
      let position;
      if(this.images.length) {
        position = 'image-left';

        if (this.settings.length) {
          const setting = this.settings.find(setting => setting.key === 'image_position');
          if (setting && setting.value !== undefined) position = setting.value;
        }
      } else {
        position = 'no-image';
      }
      
      return position;
    }
  }
};
</script>

<style lang="sass" scoped>
.content
  .content-wrap
    .content
      color: var(--color-base-text)
      @screen md
        @apply px-8

      &.colorTrans
        padding-top: 0 !important
        padding-left: 0 !important
        padding-right: 0 !important
        background-color: transparent
        &.image-left
          padding-top: 1rem !important
          @screen md
            padding-top: 0 !important
            padding-left: 1.5rem !important
        &.image-right
          padding-top: 1rem !important
          @screen md
            padding-top: 0 !important
            padding-right: 1.5rem !important

      &.colorWhite
        background-color: var(--color-descBgWhite)
      &.colorGreen
        background-color: var(--color-descBgGreen)
      &.colorGray
        background-color: var(--color-descBgGray)

      &.colorWhite,
      &.colorGreen,
      &.colorGray
        color: var(--color-descTextColor)

    &.image-left,
    &.image-right
      @screen md
        @apply grid grid-cols-2 gap-2
      .content
        @apply p-4
        @screen md
          @apply p-8 

    // IMAGE ORDER
    &.image-right
      .images
        @apply order-2
      .content
        @apply order-1
</style>
